// # #############################################
// # Title : Open Scenario Dialogue
// # Authors : Smit, Shubham, Dhruv, Atul
// # Date : 15th October 2019
// # Last Modified : Shubham, October 2019
// # Version : 19.10.03
// # Description : This is the code for the Open Scenario Table of contents view
// # ############################################

import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import GlobalEvents from "../utils/global-events";
import FilterTable from './FilterTable'
import WarningDialogue from './WarningDialogue'
import Button from '@material-ui/core/Button';


import '../css/OpenScenarioDialogue.css';

const loaderMessages = [
    "Time is an illusion. Loading time is doubly so....",
    "Please wait.. we're testing your patience...",
    "Did you know? The server is powered by a lemon and two electrodes.",
    "Please wait and dream of faster computers.",
    "Please wait, a few bits tried to escape, catching them...",
    "Prepare for awesomeness!",
    "Please wait, testing for perfection.",
    "Please wait...time is not important; only life is.",
    "Please be patient. The table should finish loading in six to eight weeks... Just kidding !",
    "Loading a virus, please relax while your life's work is being deleted...",
    "I think, therefore I am. ...loading!",
    "Making stuff up. Please wait...",
    "Getting them... they were around here somewhere..."
]

const StyledButton = withStyles(theme => ({

    root: {
        padding: '0px 8px',
        marginBottom: '0.5vh',


    },

    text: {

        "&:hover": {

            color: '#35A8BD',


        },
        paddingLeft: '2px',

        fontFamily: 'Roboto',
        fontWeight: '400',
        color: '#35A8BD',
        [theme.breakpoints.up('md')]: {
            fontSize: '30px'
        },

        [theme.breakpoints.down('md')]: {
            fontSize: 'calc(12px + 0.9vh + 0.7vw)'
        }
    },




}))(Button)



const styles = theme => ({
    noData: {

        fontWeight: '300',
        color: 'rgba(0, 0, 0, 0.47)',
        marginTop: 'calc(8vw + 1vh)',

        [theme.breakpoints.up('md')]: {
            fontSize: '30px'
        },

        [theme.breakpoints.down('md')]: {
            fontSize: 'calc(12px + 0.9vh + 0.7vw)'
        }
    },


    width: {
        [theme.breakpoints.down('xl')]: {
            margin: '0px 50px 0px 50px'
        },

        [theme.breakpoints.down('lg')]: {
            margin: '0px 20px 0px 20px'
        },

        [theme.breakpoints.down('md')]: {
            margin: '0px 10px 0px 10px'
        },

        [theme.breakpoints.down('sm')]: {
            margin: '0px'
        },
        "overflow-y": 'hidden'
    }
});

const config = require('../utils/config')

class OpenScenarioDialogue extends Component {

    constructor(props) {

        super(props);
        this.state = {
            buttonPressed: false,
            itemToBeDeleted: 0,
            openWarning: false,
            showDialog: true,
            rows: [],
            loading: true
        }

    }

    componentDidMount() {

        fetch(config.api.url + 'scenarioList/' + config.userId, {
            method: 'GET',
            mode: 'cors',
            headers: {
                "Authorization": `${config.token}`,
                "Content-Type": "application/json",
            }
        }).then(response => {
            return response.json()
        }).then(data => {
            this.setState({
                loading: false,
                rows: data
            })
        })

    }

    showDialog() {
        this.setState({
            showDialog: false
        })
        GlobalEvents.trigger('handleScenario', 0)
    }

    triggerCreateScenario() {
        this.setState({
            showDialog: false
        })

        this.props.switchPannel(1)
    }


    removeItemWarning = item => {
        this.setState({
            itemToBeDeleted: item,
            openWarning: true
        })
    }

    deleteScenario = () => {

        fetch(config.api.url + 'deleteScenario/' + this.state.itemToBeDeleted, {
            method: 'GET',
            mode: 'cors',
            headers: {
                "Authorization": `${config.token}`,
                "Content-Type": "application/json",
            }
        }).then(response => {
            if (response.ok) {
                let list = this.state.rows.filter(row => row.scenarioId !== this.state.itemToBeDeleted)
                this.setState({
                    rows: list,
                    openWarning: false,
                });
            }
        })
    }

    handleCloseWarning = () => {
        this.setState({
            openWarning: false
        })
    }

    openScenario = (item) => {
        sessionStorage.setItem("namespace", "openScenario");
        config.scenarioId = item;
        let scenario = this.state.rows.filter(row => row.scenarioId === item);
        sessionStorage.setItem("scenarioDetail", JSON.stringify(scenario));
        GlobalEvents.trigger("triggercountry", 'usa-openScenario');
    }

    render() {
        let loaderMessage = loaderMessages[Math.floor(Math.random() * loaderMessages.length)]
        return (


            <Dialog
                showNotification={this.props.showNotification}
                className="dialogWizard"
                open={this.state.showDialog}
                keepMounted
                disableBackdropClick
                disableEscapeKeyDown
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                autoDetectWindowHeight={false}
                autoScrollBodyContent={false}

                contentStyle={{
                    height: "40vh",
                    width: "100%"
                }}
                maxWidth='false'
            >
                <IconButton onClick={this.showDialog.bind(this)} color="primary" style={{ padding: "5px", position: "absolute", right: "1%", top: "1%", color: "grey" }}>
                    <CloseIcon />
                </IconButton>

                <DialogTitle id="alert-dialog-slide-title" style={{ textAlign: "center", padding: "0px", marginTop: "2%", marginBottom: '1%' }} >
                    <h2>Scenario History</h2>
                </DialogTitle>

                {

                    this.state.loading ?
                        <DialogContent id="LoaderDialogueContainerz">
                            <DialogContentText id="alert-dialog-slide-description">
                                <div className="openScenarioWizard" >
                                    <div id={"loaderContainerTable"}>
                                        <div class="lds-facebook-table"><div></div><div></div><div></div></div>
                                        <div style={{ fontSize: 'calc(1vw + 1vh)', marginTop: '2vh' }}>{loaderMessage}</div>
                                    </div>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        :
                        this.state.rows.length === 0 ?
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    <div style={{ display: 'flex', flexDirection: 'column' }} className="openScenarioWizard" >
                                        <div className={this.props.classes.noData}>There are no scenarios saved in your profile.
                                Kindly <StyledButton onClick={this.triggerCreateScenario.bind(this)} > create a new scenario </StyledButton> </div>
                                    </div>
                                </DialogContentText>
                            </DialogContent>
                            :
                            <Fragment>
                                <DialogContent className={this.props.classes.width}>
                                    <DialogContentText id="alert-dialog-slide-description">
                                        <div className="openScenarioWizard"  >
                                            <FilterTable
                                                items={this.state.rows}
                                                delete={(item) => this.removeItemWarning(item)}
                                                openScenario={(item) => this.openScenario(item)}
                                                showNotification={this.props.showNotification}
                                                switchPannel={this.props.switchPannel}
                                            />
                                            <WarningDialogue
                                                handleCloseWarning={this.handleCloseWarning.bind(this)}
                                                open={this.state.openWarning}
                                                handleAction2={this.deleteScenario.bind(this)}
                                                title="Delete Scenario"
                                                body="Are you sure you want to delete?"
                                                action1='Cancel'
                                                action2="Delete"
                                            />
                                        </div>
                                    </DialogContentText>
                                </DialogContent>
                            </Fragment>
                }


            </Dialog >



        );
    }
}

OpenScenarioDialogue.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired
}

export default withStyles(styles)(OpenScenarioDialogue);
